import { render, staticRenderFns } from "./editMaintainanceItem.vue?vue&type=template&id=53d1008f"
import script from "./editMaintainanceItem.vue?vue&type=script&lang=js"
export * from "./editMaintainanceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports